import "./config/config.flow/styles.css"
import { Fragment, createContext } from "react"
import { Theme, styles } from "./config/config.flow"
import { Stack, Box, Container } from "@mui/material"
import { Formik, Form } from "formik"
import Roadmap from "./Roadmap"
import StripeLayout from "../../StripeLayout"

// Create a context for handlers
export const FlowHandlersContext = createContext(null);

export default function FlowContainer(props) {
    
    const { ready, roadmap, roadmapIndex, hideSidebar, handlers, validationSchema, validateOnChange = true, validateOnBlur = false } = props
    const { children, initialValues, handleSubmit } = props
    
    return ready ? (
        <StripeLayout>
            <Box
                sx={{
                    pt: { xs: "40px", sm: "56px" },
                    pb: { xs: "40px", sm: "56px" },
                }}
            >
                <Container>
                    <Theme>
                        <Stack sx={styles.container} aria-label="flow-container">
                            <Stack sx={styles.flowContainer} aria-label="flow-container-content">
                                {!hideSidebar && <Roadmap roadmap={roadmap} roadmapIndex={roadmapIndex} />}
                                <Stack sx={styles.form} aria-label="flow-container-form">
                                    <Formik 
                                        initialValues={initialValues} 
                                        onSubmit={handleSubmit} 
                                        validationSchema={validationSchema}
                                        validateOnChange={validateOnChange}
                                        validateOnBlur={validateOnBlur}
                                        enableReinitialize={true}
                                    >
                                        {(formik) => (
                                            <Form aria-label="flow-container-form-form">
                                                <FlowHandlersContext.Provider value={handlers}>
                                                    {children(formik)}
                                                </FlowHandlersContext.Provider>
                                            </Form>
                                        )}
                                    </Formik>
                                </Stack>
                            </Stack>
                        </Stack>
                    </Theme>
                </Container>
            </Box>
        </StripeLayout>
    ) : (
        <StripeLayout>
            <Fragment />
        </StripeLayout>
    )
}
